import { JsonApiClient } from "@/modules/api/utils/createJsonApiClient/createJsonApiClient";
import {
  resetPasswordResourcePath,
  resetPasswordResourceType,
} from "@/modules/auth/api/resources/resetPassword/resetPasswordConsts";

export function resetPasswordMutation(jsonApi: JsonApiClient) {
  return (attributes: { token: string; newPassword: string }) =>
    jsonApi.put({
      type: resetPasswordResourceType,
      path: resetPasswordResourcePath,
      attributes,
    });
}
